'use strict';

export default class SetPasswordController {
  user = {
    token: '',
    password: ''
  };
  submitted = false;
  AuthSvc;
  $state;

  constructor(AuthSvc, $state, $location, ToastrSvc) {
    // redirect to main if already logged in
    var setToken = $location.search().set;
    AuthSvc.isLoggedIn(function(loggedIn) {
      if(loggedIn) { return $state.go('main'); }
      AuthSvc.checkToken(setToken)
        .catch(() => {
          ToastrSvc.error('Invalid password reset link.');
          $state.go('login');
        });
    });
    this.AuthSvc = AuthSvc;
    this.$state = $state;
    this.ToastrSvc = ToastrSvc;
    this.user.token = setToken;
  }

  submit(form) {
    this.submitted = true;

    if(form.$valid) {
      this.AuthSvc.setPassword(this.user.token, this.user.password)
        .then(() => {
          this.ToastrSvc.success('Your password has been reset.');
          // Logged in, redirect to home
          this.$state.go('main');
        })
        .catch(err => {
          this.ToastrSvc.error(err.message);
        });
    }
  }
}

SetPasswordController.$inject = ['AuthSvc', '$state', '$location', 'ToastrSvc'];
